/* VariantPickCell — the per-row Variant picker in Add to Project: a
   SearchableSelect of "Office Master" + the master's variants (layers).
   Extracted verbatim from AddSpecs.tsx. A master with no variants shows a
   muted dash. */
import React from 'react';
import { SearchableSelect } from './SearchableSelect';

export interface VariantPickCellProps {
  /** The master's variants (layers). */
  layers: { id: string; name?: string }[];
  /** Selected layer id, or `officeMaster` when none. */
  value: string | undefined;
  /** Sentinel value meaning "Office Master" (no variant). */
  officeMaster: string;
  /** Section number or title — only used in the aria label. */
  label: string;
  onChange: (value: string) => void;
}

export function VariantPickCell({
  layers,
  value,
  officeMaster,
  label,
  onChange,
}: VariantPickCellProps) {
  if (layers.length === 0) return <span style={{ color: 'var(--tm)' }}>{'—'}</span>;
  return (
    <div onClick={(e) => e.stopPropagation()} style={{ width: '100%' }}>
      <SearchableSelect
        value={value || officeMaster}
        options={[
          { value: officeMaster, label: 'Office Master' },
          ...layers.map((l) => ({ value: l.id, label: l.name || 'Untitled variant' })),
        ]}
        onChange={(v) => onChange(v || officeMaster)}
        clearable={false}
        ariaLabel={`Variant for ${label}`}
        searchPlaceholder="Search variants…"
      />
    </div>
  );
}

export default VariantPickCell;
